import React from 'react';
import {
  FormTitleWrapper,
  FormTextWrapper,
  Notice,
  FormNoticeWrapper,
  FormDate,
  GroupFormDate,
} from 'page/Application/ManageCompanyList/component/Form/FormTitle/styled';
import { LineVertical } from 'components/Button';
import { DATE_FORMAT_LIST } from 'constant/notificationConstants';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const FormTitle = ({ title, styles, type, notice, dataDate }) => {
  const createdTime = dataDate?.createdTime
    ? dayjs
        .utc(dataDate.createdTime)
        .tz('Asia/Tokyo')
        ?.format(DATE_FORMAT_LIST[4])
    : '';
  const updatedTime = dataDate?.updatedTime
    ? dayjs
        .utc(dataDate.updatedTime)
        .tz('Asia/Tokyo')
        ?.format(DATE_FORMAT_LIST[4])
    : '';
  const lastLoginTime = dataDate?.lastLoginTime
    ? dayjs
        .utc(dataDate.lastLoginTime)
        .tz('Asia/Tokyo')
        ?.format(DATE_FORMAT_LIST[4])
    : '-';

  return type === 'title' ? (
    <FormTitleWrapper style={styles}>{title}</FormTitleWrapper>
  ) : (
    <FormNoticeWrapper>
      <div>
        <Notice style={styles}>{notice}</Notice>
        <FormTextWrapper style={styles}>{title}</FormTextWrapper>
      </div>
      {dataDate && (
        <GroupFormDate>
          <FormDate>登録日時 {createdTime}</FormDate>
          <LineVertical />
          <FormDate>更新日時 {updatedTime}</FormDate>
          {dataDate?.hasOwnProperty('lastLoginTime') && (
            <>
              <LineVertical />
              <FormDate>最終ログイン日時 {lastLoginTime}</FormDate>
            </>
          )}
        </GroupFormDate>
      )}
    </FormNoticeWrapper>
  );
};

export default FormTitle;
